/*
 * Único punto de redirección "dura" (recarga completa del navegador).
 * Centralizarlo permite mockearlo en pruebas unitarias.
 */
export function hardRedirect(path) {
  window.location.href = path
}
